import StyledSvg from '@gef-ui/material-svg-shared/StyledSvg';
import * as React from 'react';
const SvgCustomerRelationshipFidelityLow = (props)=>{
    const id = React.useId();
    return /*#__PURE__*/ React.createElement(StyledSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: `url(#customer-relationship-fidelity-low_svg__a-${id})`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E4EFFA",
        d: "M53 26.505v-.02c0-3.475-.69-6.908-2.02-10.114a26.6 26.6 0 0 0-5.741-8.598 26.5 26.5 0 0 0-8.597-5.752A26.5 26.5 0 0 0 26.5 0c-3.484 0-6.927.68-10.142 2.02A26.4 26.4 0 0 0 7.76 7.774a26.4 26.4 0 0 0-5.74 8.598A26.6 26.6 0 0 0 0 26.485v.03c0 3.475.69 6.908 2.02 10.114a26.6 26.6 0 0 0 5.741 8.598 26.5 26.5 0 0 0 8.597 5.752A26.5 26.5 0 0 0 26.5 53c3.484 0 6.926-.68 10.142-2.02a26.4 26.4 0 0 0 8.597-5.753 26.4 26.4 0 0 0 5.74-8.598A26.6 26.6 0 0 0 53 26.516z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#385B66",
        d: "M8.206 7.807h36.19c3.397 0 3.397 0 3.397 3.397v22.879H4.81v-22.89c0-3.396 0-3.396 3.397-3.396z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#A8C3DD",
        d: "M46.189 9.781H6.417a.645.645 0 0 0-.645.645V32.68c0 .355.29.644.645.644H46.19a.645.645 0 0 0 .645-.645V10.427a.645.645 0 0 0-.645-.645"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#DBE7E3",
        d: "M50.895 37.541H1.699l3.11-3.397h42.985z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#385B66",
        d: "M1.7 37.542h49.185c0 1.033-.84 1.872-1.873 1.872H3.572a1.873 1.873 0 0 1-1.873-1.872"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#6E878E",
        d: "M30.133 37.153h-7.91a.198.198 0 0 1-.194-.246l.205-.91a.2.2 0 0 1 .194-.154h7.5c.093 0 .174.061.195.154l.204.91c.031.123-.071.246-.194.246M46.455 35.464H6.295a.093.093 0 0 1-.072-.153l.44-.604s.04-.041.071-.041h39.27s.062.01.072.04l.44.605c.041.061 0 .153-.071.153z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E4EFFA",
        d: "M6.14 9.781a.367.367 0 0 0-.368.369V31.38s1.402-11.143 5.526-15.276c4.604-4.625 12.513-6.19 13.434-6.313H6.141z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M37.388 13H14.612c-.89 0-1.612.743-1.612 1.66v13.68c0 .917.722 1.66 1.612 1.66h22.776c.89 0 1.612-.743 1.612-1.66V14.66c0-.917-.722-1.66-1.612-1.66"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#CD9A83",
        d: "M37.48 24.883s-3.08-1.126-3.438-1.28c-.358-.153-1.074 3.234 3.438 4.523 4.513 1.28 0-3.233 0-3.233z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#A8C3DD",
        d: "M37.52 28.505h-.542v1.115h.543zM37.52 30.164h-.542v1.616h.543zM37.52 32.342h-.542v1.617h.543z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M36.028 26.317h-.522v1.064h.522zM36.028 27.902h-.522v1.544h.522zM36.028 29.98h-.522v1.545h.522z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#A8C3DD",
        d: "M44.274 39.312a5.096 5.096 0 1 0 0-10.191 5.096 5.096 0 0 0 0 10.19"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        d: "M55.909 54.627c-.185-1.862-1.034-4.031-1.034-4.031l-2.814-5.546H41.236s-.164 5.884 5.136 8.892c0 0 .297.849.205 2.046h9.403c0-.46-.03-.92-.071-1.36"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        d: "M50.822 35.146s1.586.051 2.047 1.596c.46 1.535.245 10.406.245 10.406zM35.271 40.241s-1.258 3.438-1.484 4.083 2.794.307 3.52-1.453c.41-.992.768-3.54.03-3.99-.408-.246-2.066 1.36-2.066 1.36"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        d: "M34.32 37.029s-1.136 3.07-1.351 3.918c-.215.84 2.363.747 3.898-1.545 1.525-2.292.665-4.338.665-4.338l-3.213 1.975z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#CD9A83",
        d: "M37.398 33.612s-2.015-.082-2.732.47c-.726.563-2.056 1.863-2.588 2.282s1.084 2.793 4.655-.123c3.571-2.906.665-2.64.665-2.64z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M37.88 21.539c-.973 0-1.853 1.002-1.853 1.974V45.42c0 .972.952 1.954 1.924 1.954h8.779c.972 0 1.954-.951 1.954-1.934V23.493c0-.972-.88-1.954-1.852-1.954H37.88"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#C21B17",
        d: "M46.76 47.69h-8.83a2.26 2.26 0 0 1-2.25-2.25V23.472a2.26 2.26 0 0 1 2.25-2.251h8.83a2.26 2.26 0 0 1 2.252 2.25V45.44a2.26 2.26 0 0 1-2.251 2.25m-8.83-25.978a1.77 1.77 0 0 0-1.77 1.77V45.45c0 .972.789 1.77 1.77 1.77h8.83a1.77 1.77 0 0 0 1.771-1.77V23.482a1.77 1.77 0 0 0-1.77-1.77z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M49.196 27.728h-.522v2.169h.522z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        d: "M24 28a2 2 0 1 0 0-4 2 2 0 0 0 0 4M18 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        d: "M23.892 26s-.066-.01-.087-.042l-4.795-5.776s-.033-.115.022-.156c.054-.042.12-.032.163.02l4.795 5.777s.033.115-.022.156c-.021.021-.043.021-.076.021"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        d: "M24.114 26s-.065-.01-.087-.039c-.043-.039-.032-.107.011-.146l8.772-6.805s.12-.029.162.01c.044.04.033.107-.01.146l-8.772 6.805s-.055.029-.076.029M36.165 35c-.093 0-.165-.219-.165-.5s.072-.5.165-.5h12.67c.093 0 .165.219.165.469s-.072.5-.165.5h-12.67z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        d: "M42.535 38.791a4.287 4.287 0 1 0 0-8.574 4.287 4.287 0 0 0 0 8.574"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M42.535 37.268a2.764 2.764 0 0 1-2.762-2.763 2.764 2.764 0 0 1 2.762-2.763 2.764 2.764 0 0 1 2.763 2.763 2.764 2.764 0 0 1-2.763 2.763m0-5.198a2.44 2.44 0 0 0-2.435 2.435 2.44 2.44 0 0 0 2.435 2.435 2.44 2.44 0 0 0 2.435-2.435 2.44 2.44 0 0 0-2.435-2.435"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M41.573 33.503s.062.03.062.062c0 .03-.031.06-.062.06a.066.066 0 0 1-.061-.06c0-.031.03-.062.061-.062"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M41.573 33.79a.227.227 0 0 1-.225-.226c0-.122.102-.225.225-.225s.225.103.225.225a.227.227 0 0 1-.225.225m0-.328a.103.103 0 0 0-.103.102c0 .113.205.113.205 0a.103.103 0 0 0-.102-.102M43.507 33.503s.061.03.061.062c0 .03-.03.06-.061.06a.066.066 0 0 1-.062-.06c0-.031.031-.062.062-.062"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M43.506 33.79a.227.227 0 0 1-.225-.226c0-.122.103-.225.225-.225s.225.103.225.225a.227.227 0 0 1-.225.225m0-.328a.103.103 0 0 0-.102.102c0 .113.205.113.205 0a.103.103 0 0 0-.103-.102M42.536 36.01c-.686 0-1.29-.461-1.474-1.116a.175.175 0 0 1 .113-.205c.092-.02.174.03.204.113.144.511.625.88 1.157.88s1.012-.358 1.156-.88a.154.154 0 0 1 .204-.113c.093.02.144.113.113.205a1.535 1.535 0 0 1-1.474 1.115"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#B98063",
        d: "M50.337 31.105c-.198-.734.05-3.052-.497-3.104s-2.614 1.95-2.296 4.362c.547 4.152.537 6.899-.02 9.09-.676 2.642-3.062 7.518 0 10.936s7.476.335 7.476.335-4.464-20.896-4.663-21.63z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#CD9A83",
        fillRule: "evenodd",
        d: "M47 50.502a5.6 5.6 0 0 0 1.077 1.92c2.836 3.348 7.423.078 7.423.078s-4.816-19.781-5-20.5c-.064-.267-.315-1.352-.324-1.844-.01-.483.064-1.012 0-1.361-1.233 2.567-.82 7.753-.644 8.78.156.934.497 2.567.644 3.265-.939 1.263-2.743 4.805-3.176 9.673z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M43.5 34a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M41.5 34a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#AB1F08",
        d: "M33 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: `customer-relationship-fidelity-low_svg__a-${id}`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h56v56H0z"
    }))));
};
export default SvgCustomerRelationshipFidelityLow;
